import React from 'react';
import Button from 'components/DesignSystem/Button';

export default function EditButton({
  onClick,
  id,
} : {
  onClick: () => void,
  id: number,
}) {
  return (
    <Button
      id={`edit-video-${id}`}
      small
      className="icon-button video-action-button"
      onClick={() => onClick()}
      icon="edit"
    />
  );
}
